module.exports = __webpack_public_path__ + "static/media/AandB.ef5d091b.svg";